/**
 * AnalyzersPage Route Component
 *
 * Page component integrating AnalyzersList
 */

import React from "react";
import AnalyzersList from "../components/analyzers/AnalyzersList/AnalyzersList";

const AnalyzersPage = () => {
  return <AnalyzersList />;
};

export default AnalyzersPage;
